import React from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyCategory, fetchCategories } from "../../../../actions/mine_craft/categoriesActions";
import {
  CategoryInterface,
  setEditId,
  setNewParams,
  setReorderIds
} from "../../../../store/mine_craft/categoriesSlice";

import { message } from "antd";
import { Link } from "react-router-dom";
import ListVertical from "../../../../componets/ListVertical";
import { ButtonCreate, ButtonDestroy, ButtonEdit, ButtonReorder } from "../../../../componets/Buttons";

const _ListItem = ({ category, activeId }: { category: CategoryInterface | undefined; activeId?: number}) => {
  const dispatch = useAppDispatch();
  const isParent = category?.parent_id === null;
  const options = [
    <ButtonEdit key={`edit-${category?.id}`} onClick={onClickEdit} />,
    <ButtonDestroy key={`destroy-${category?.id}`} onClick={onClickDestroy} />
  ]

  if (isParent) {
    options.push(
      <ButtonReorder key={`reorder-${category?.id}`} title='Reorder Subcategory' onClick={onClickReorderSubcategories} />
    )
    options.push(
      <ButtonCreate key={`create-${category?.id}`} title='Create Subcategory' onClick={onClickCreateSubcategory} />
    )
  }

  function onClickCreateSubcategory() {
    if (category) {
      dispatch(setNewParams({ target_id: category.target_id, parent_id: category.id }))
    }
  }

  function onClickReorderSubcategories() {
    if (category) {
      dispatch(setReorderIds({ids: category.subcategories, reorderParentId: category.id}));
    }
  }

  function onClickEdit() {
    if (category) {
      dispatch(setEditId(category.id));
    }
  }

  function onClickDestroy() {
    if (category) {
      handleDestroy(category.id).catch(console.error);
    }
  }

  async function handleDestroy(id: any) {
    const resultAction = await dispatch(destroyCategory(id));

    if (!category) {
      return;
    }

    if (destroyCategory.fulfilled.match(resultAction)) {
      dispatch(fetchCategories({ target_id: category.target_id }));
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyCategory.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  if (!category) {
    return null;
  }

  return (
    <ListVertical.Item
      key={category.id}
      parent={isParent}
      active={category.id === activeId}
      image={category.image_url}
      options={{
        options,
        placement: 'leftTop'
      }}
    >
      <Link to={category.url}>{category.title}</Link>
    </ListVertical.Item>
  )
}

export default _ListItem;
